import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Divider,
  useTheme,
} from '@mui/material';

interface FooterProps {
  variant?: 'default' | 'minimal';
}

export const Footer: React.FC<FooterProps> = ({ variant = 'default' }) => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  if (variant === 'minimal') {
    return (
      <Box
        component="footer"
        sx={{
          py: 2,
          px: 3,
          borderTop: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          align="center"
          component="div"
        >
          © {currentYear} ガクフドキャリア. All rights reserved.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 4,
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', md: 'flex-start' },
            gap: 3,
          }}
        >
          {/* Company Info */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: theme.palette.primary.main,
                mb: 1,
              }}
            >
              ガクフドキャリア
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ maxWidth: 300 }}
            >
              AI技術を活用した不動産実践活動支援ツール。
              学生の学習体験を革新します。
            </Typography>
          </Box>

          {/* Links Section */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: { xs: 2, sm: 4 },
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, mb: 1 }}
              >
                プロダクト
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Link
                  href="#"
                  variant="body2"
                  color="text.secondary"
                  underline="hover"
                >
                  AI学習チャット
                </Link>
                <Link
                  href="#"
                  variant="body2"
                  color="text.secondary"
                  underline="hover"
                >
                  エキスパートAI
                </Link>
                <Link
                  href="#"
                  variant="body2"
                  color="text.secondary"
                  underline="hover"
                >
                  分析ダッシュボード
                </Link>
              </Box>
            </Box>

            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, mb: 1 }}
              >
                サポート
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Link
                  href="#"
                  variant="body2"
                  color="text.secondary"
                  underline="hover"
                >
                  ヘルプセンター
                </Link>
                <Link
                  href="#"
                  variant="body2"
                  color="text.secondary"
                  underline="hover"
                >
                  お問い合わせ
                </Link>
                <Link
                  href="/terms"
                  variant="body2"
                  color="text.secondary"
                  underline="hover"
                >
                  利用規約
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="caption" color="text.secondary">
            © {currentYear} ガクフドキャリア. All rights reserved.
          </Typography>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Link
              href="/terms"
              variant="caption"
              color="text.secondary"
              underline="hover"
            >
              利用規約
            </Link>
            <Link
              href="/privacy-policy"
              variant="caption"
              color="text.secondary"
              underline="hover"
            >
              プライバシーポリシー
            </Link>
            <Link
              href="#"
              variant="caption"
              color="text.secondary"
              underline="hover"
            >
              クッキーポリシー
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;